module.exports = __webpack_public_path__ + "img/trip(1).005b4c0d.webp";